export default "__VITE_ASSET__BM5KxnG5__"